import React, { useContext } from 'react'
import { NewContext } from '../../Context/NewContext'
import { Modal } from '@mui/material';
import { Box } from '@mui/system';

const HomeActivityPDF = () => {
    const { open, handleClose } = useContext(NewContext);
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        // sx={{
        //     ".MuiBox-root": {
        //         width: "100%",
        //         maxWidth: `${currentHomeModalKey === "add" ? "395px" : "1200px"}`,
        //         borderRadius: "12px" // Set your width here
        //     },
        // }}
        >
            <Box className='p-8 bg-white' sx={{ border: "none" }}>
                PDF
            </Box>
        </Modal >
    )
}

export default HomeActivityPDF